import {cn} from 'platform/shared-tw';

import {CSSProperties} from 'react';

interface RulerProps {
  title: string;
  length: string;
  className?: string;
  style?: CSSProperties;
  orientation?: 'horizontal' | 'vertical';
}

export function Ruler(props: RulerProps) {
  const orientation = props.orientation ?? 'horizontal';

  if (orientation === 'vertical') {
    return (
      <div className={cn('flex flex-row items-center gap-1', props.className)} style={props.style}>
        {/* Label — rotated vertically */}
        <p
          className="whitespace-nowrap text-xs text-(--color-mira-gray-50)"
          style={{writingMode: 'vertical-rl', transform: 'rotate(180deg)'}}
        >
          {props.title}{' '}
          <strong className="font-medium text-(--color-mira-gray-100)">{props.length}</strong>
        </p>
        {/* Tick marks — vertical, ticks point right */}
        <div
          className="w-3 shrink-0 bg-no-repeat text-(--color-mira-gray-20)"
          style={{
            height: '100%',
            backgroundSize: '6px 100%, 10px 100%, 12px 100%',
            backgroundPosition: 'right top, right top, right top',
            backgroundImage:
              'repeating-linear-gradient(180deg,currentColor 0 1px,transparent 1px 8px),repeating-linear-gradient(180deg,currentColor 0 1px,transparent 1px 40px),repeating-linear-gradient(180deg,currentColor 0 1px,transparent 1px 80px)',
          }}
        />
      </div>
    );
  }

  return (
    <div className={cn('relative', props.className)}>
      {/* Tick marks — horizontal */}
      <div
        className="h-4 bg-no-repeat text-(--color-mira-gray-20)"
        style={{
          backgroundSize: '100% 6px, 100% 10px, 100% 16px',
          backgroundPosition: 'left bottom, left bottom, left bottom',
          backgroundImage:
            'repeating-linear-gradient(90deg,currentColor 0 1px,transparent 1px 8px),repeating-linear-gradient(90deg,currentColor 0 1px,transparent 1px 40px),repeating-linear-gradient(90deg,currentColor 0 1px,transparent 1px 80px)',
        }}
      />
      {/* Label */}
      <p className="pt-2 text-center text-xs text-(--color-mira-gray-50)">
        {props.title}{' '}
        <strong className="font-medium text-(--color-mira-gray-100)">{props.length}</strong>
      </p>
    </div>
  );
}
